// ========================================================================
// This file is auto-generated by the `yarn naptime:types` script
// ========================================================================
import NaptimeResource from 'bundles/naptimejs/resources/NaptimeResource';

// ========================================================================
// Definitions for resource data types
// ========================================================================

export type CourserianRole =
  | 'partnerOps'
  | 'courserian'
  | 'engineer'
  | 'finance'
  | 'parma'
  | 'dataShare'
  | 'piiUser'
  | 'analyst'
  | 'communityOperations'
  | 'flexOps'
  | 'IT'
  | 'etam'
  | 'infra'
  | 'dataAdmin';

export interface Courserian {
  email: string;
  name: string;
  roles: Array<CourserianRole>;
  username: string;
}

export interface OutsourcingPermissionENROLL_WITH_CERTIFICATE {
  typeName: 'eNROLL_WITH_CERTIFICATE';
  definition: any;
}

export interface OutsourcingPermissionREFUND_WITHIN_DEADLINE {
  typeName: 'rEFUND_WITHIN_DEADLINE';
  definition: any;
}

export interface OutsourcingPermissionREAD_SALESFORCE_LEAD {
  typeName: 'rEAD_SALESFORCE_LEAD';
  definition: any;
}

export interface OutsourcingPermissionENROLL_FOR_FREE {
  typeName: 'eNROLL_FOR_FREE';
  definition: any;
}

export interface OutsourcingPermissionSEARCH_USERS {
  typeName: 'sEARCH_USERS';
  definition: any;
}

export interface OutsourcingPermissionREFUND_AFTER_DEADLINE {
  typeName: 'rEFUND_AFTER_DEADLINE';
  definition: any;
}

export interface OutsourcingPermissionPHOTO_REVIEW {
  typeName: 'pHOTO_REVIEW';
  definition: any;
}

export interface OutsourcingPermission$UNKNOWN {
  typeName: '$UNKNOWN';
  definition: any;
}

export interface OutsourcingPermissionDEGREES {
  typeName: 'dEGREES';
  definition: any;
}

export interface OutsourcingPermissionEDIT_OUTSOURCING {
  typeName: 'eDIT_OUTSOURCING';
  definition: any;
}

export interface OutsourcingPermissionCREATE_INVOICE {
  typeName: 'cREATE_INVOICE';
  definition: any;
}

export interface OutsourcingPermissionVIEW_PAYMENT_INFORMATION {
  typeName: 'vIEW_PAYMENT_INFORMATION';
  definition: any;
}

export interface OutsourcingPermissionENTERPRISE {
  typeName: 'eNTERPRISE';
  definition: any;
}

export type OutsourcingPermission =
  | OutsourcingPermissionENROLL_WITH_CERTIFICATE
  | OutsourcingPermissionREFUND_WITHIN_DEADLINE
  | OutsourcingPermissionREAD_SALESFORCE_LEAD
  | OutsourcingPermissionENROLL_FOR_FREE
  | OutsourcingPermissionSEARCH_USERS
  | OutsourcingPermissionREFUND_AFTER_DEADLINE
  | OutsourcingPermissionPHOTO_REVIEW
  | OutsourcingPermission$UNKNOWN
  | OutsourcingPermissionDEGREES
  | OutsourcingPermissionEDIT_OUTSOURCING
  | OutsourcingPermissionCREATE_INVOICE
  | OutsourcingPermissionVIEW_PAYMENT_INFORMATION
  | OutsourcingPermissionENTERPRISE;

export type OutsourcingPermissionTypeName =
  | 'eNROLL_WITH_CERTIFICATE'
  | 'rEFUND_WITHIN_DEADLINE'
  | 'rEAD_SALESFORCE_LEAD'
  | 'eNROLL_FOR_FREE'
  | 'sEARCH_USERS'
  | 'rEFUND_AFTER_DEADLINE'
  | 'pHOTO_REVIEW'
  | '$UNKNOWN'
  | 'dEGREES'
  | 'eDIT_OUTSOURCING'
  | 'cREATE_INVOICE'
  | 'vIEW_PAYMENT_INFORMATION'
  | 'eNTERPRISE';

export interface PrivilegedAuthsV1 {
  id: string;
  courserian?: Courserian | null;
  isInternal: boolean;
  isSuperuser: boolean;
  outsourcingPermissions: Array<OutsourcingPermission>;
}

// ========================================================================
// Definitions for naptime-link
// ========================================================================

export interface PrivilegedAuthsV1Connection {
  elements: Array<PrivilegedAuthsV1> | null;
}

// ========================================================================
// Definitions for naptime-link queries
// ========================================================================

export interface PrivilegedAuthsV1MeQuery {
  PrivilegedAuthsV1: {
    me: PrivilegedAuthsV1Connection | null;
  } | null;
}

export interface PrivilegedAuthsV1MeQueryVariables {
  includes?: string | null;
}

// ========================================================================
// Definitions for naptime-js
// ========================================================================

// Recursively applies Partial<T> to supported culling by the `fields` param.
type PartialConstruction<T> = {
  [TKey in keyof T]?: T[TKey] extends Array<infer TElement>
    ? Array<PartialConstruction<TElement>>
    : T[TKey] extends object
    ? PartialConstruction<T[TKey]>
    : T[TKey];
};

export class PrivilegedAuthsV1NaptimeResource extends NaptimeResource {
  static RESOURCE_NAME = 'privilegedAuths.v1' as const;

  declare id: string;

  declare courserian?: Courserian | null;

  declare isInternal: boolean;

  declare isSuperuser: boolean;

  declare outsourcingPermissions: Array<OutsourcingPermission>;

  // Intentionally "useless" to supply params type
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(params: PartialConstruction<PrivilegedAuthsV1>) {
    super(params);
  }
}
